import React from 'react';
import {connect} from "react-redux";
import {withNamespaces} from "react-i18next";
import {claimTypes} from "../../../../constants/claim.constants";
import {Link} from "react-router-dom";
import {Button} from "react-bootstrap";
import {modalActions} from "../../../../actions/modal.actions";
import {networkResetDeviceActions} from "../../../../actions/network-reset-device.actions";
import {history} from "../../../../helpers/history";

const NetworkResetDeviceActionButtons = ({t, row, user, size = "", showModal, removeResetDevice, hideModal, manualReset, clearState}) => {

    const claims = {
        crudBtn: user[`c_network-device.actions.crud`] || null,
    }

    const openModalRemoveDevice = (model) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('delete-msg') + `<h5> ${model.resetator.label} </h5>`,
            confirmLabel: t('delete-btn'),
            confirmIcon: 'fa-trash',
            classNameBtnConfirm: 'btn-danger',
            dataId: model.id,
            confirmAction: (id) => {
                removeResetDevice(id);
                hideModal();
            },
            closeModal: closeModal,
        }, 'confirm')
    };

    const openModalManualReset = (model) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('manual-reset-msg') + `<h5> ${model.resetator.label} </h5>`,
            confirmLabel: t('manual-reset'),
            confirmIcon: 'fa-plug',
            classNameBtnConfirm: 'btn-warning',
            dataId: model.id,
            confirmAction: (id) => {
                manualReset(id);
                hideModal();
            },
            closeModal: closeModal,
        }, 'confirm')
    }

    const openModalClearState = (model) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('clear-state-msg') + `<h5> ${model.resetator.label} </h5>`,
            confirmLabel: t('clear-state'),
            confirmIcon: 'fa-info-circle',
            classNameBtnConfirm: 'btn-danger',
            dataId: model.id,
            confirmAction: (id) => {
                clearState(id);
                hideModal();
            },
            closeModal: closeModal,
        }, 'confirm')
    }

    const closeModal = () => {
        hideModal()
    };

    const goTo = (routing) => {
        history.push(routing);
    }

    return (
        <React.Fragment>
            {/*ultra large resolution*/}
            <div>

                { row.hasError ? (
                    <Button variant={"danger"} size={size} className="mx-1" onClick={() => openModalClearState(row)}>
                        <i className="fas fa-info-circle"/> &nbsp; { t('reset-state') }
                    </Button>
                ) : (<React.Fragment/>) }

                <Button variant={"warning"} size={size} className="mx-1" onClick={() => openModalManualReset(row)}>
                    <i className="fas fa-plug"/> &nbsp; { t('manual-reset') }
                </Button>

                { claims.crudBtn === claimTypes.READ_WRITE ? (
                    <Link to={"/panel/network-reset-device/edit/" + row.id}>
                        <Button variant={"primary"} size={size} className="mx-1">
                            <i className="fas fa-edit"> </i>
                        </Button>
                    </Link>
                ) : (<React.Fragment/>) }

                { claims.crudBtn === claimTypes.READ_WRITE ? (
                    <Button variant={"danger"} size={size} className="mx-1" onClick={() => openModalRemoveDevice(row)}>
                        <i className="fas fa-trash"> </i>
                    </Button>
                ) : (<React.Fragment/>) }
            </div>
        </React.Fragment>
    )
}
const mapStateToProps = (state) => {
    const { user } = state.authenticationReducer;
    return {
        user
    }
}
const mapDispatchToProps = dispatch => ({
    hideModal: () => dispatch(modalActions.hideModal()),
    removeResetDevice: (id) => dispatch(networkResetDeviceActions.removeDeviceById(id)),
    manualReset: (id) => dispatch(networkResetDeviceActions.manualReset(id)),
    clearState: (id) => dispatch(networkResetDeviceActions.clearState(id)),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({ modalProps, modalType }))
    }
});
export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(NetworkResetDeviceActionButtons))
